import { PaginatedProjects } from '@dc-shared-web/hooks/api/project/types'
import { AxiosInstance } from 'axios'

export type GetProjectInfoQueryParams = {
  teamUUID: string | undefined
  nameQuery: string | undefined
  page?: number
  limit?: number
  enabled?: boolean
  folderUUID?: string
  parentDash?: boolean
}

export const fetchProjectInfo = async (
  apiClient: AxiosInstance,
  params?: GetProjectInfoQueryParams
): Promise<PaginatedProjects> => {
  let parent_dash = params?.parentDash
  if (params?.folderUUID) {
    parent_dash = false
  }

  const res = await apiClient.get(
    `/api/project-info/office/${params?.teamUUID}`,
    {
      params: {
        name: params?.nameQuery,
        limit: params?.limit ?? 50,
        page: params?.page,
        folder_uuid: params?.folderUUID,
        sortBy: 'name',
        parent_dash,
      },
    }
  )

  return res.data
}
